import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild, ViewRef } from '@angular/core';
import { CalculationKeynameEnum } from '../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { BehaviorSubject, Subscription } from 'rxjs';
import { NgbOffcanvas, OffcanvasDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToolboxStateEnum } from './toolbox-state.enum';
import {
  QuickCalculationManager,
} from '../../../../../modules/src/lib/calculations/managers/quick-calculation.manager';
import {
  QuickCalculationCacheModel,
} from '../../../../../modules/src/lib/calculations/models/quick-calculation-cache.model';
import { DateUtils } from '../../../../../modules/src/lib/core/utils/date.utils';
import { EventStore } from '../../stores/event.store';

@Component({
  selector: 'app-right-sidebar',
  templateUrl: './right-sidebar.component.html',
  styleUrls: ['./right-sidebar.component.scss'],
  standalone: false,
})
export class RightSidebarComponent implements OnInit, OnDestroy {

  public state = ToolboxStateEnum.Home;
  public ToolboxStateEnum = ToolboxStateEnum;
  public quickCalculations$: BehaviorSubject<QuickCalculationCacheModel[]> = new BehaviorSubject<QuickCalculationCacheModel[]>([]);
  quickCalculationSelected: QuickCalculationCacheModel | undefined;
  @ViewChild('content')
  content!: TemplateRef<any>;
    protected readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly offcanvasService: NgbOffcanvas,
    private readonly quickCalculationManager: QuickCalculationManager,
    private readonly dateUtils: DateUtils,
    private readonly eventStore: EventStore,
  ) {
  }

  async ngOnInit() {
    this.subscriptions.push(this.eventStore.openQuickCalculation$.subscribe(value => {
      if (value) {
        this.open(this.content);
      }
    }));
    this.refreshCache();
  }

  async ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  open(content: TemplateRef<any>) {
    this.offcanvasService.open(content, {
      ariaLabelledBy: 'offcanvas-basic-title',
      scroll: true,
      backdrop: false,
      position: 'end',
      panelClass: 'w-25 shadow',
    }).result.then(
      (result) => {
        console.log(`Closed with: ${result}`);
      },
      (reason) => {
        console.log(`Dismissed ${this.getDismissReason(reason)}`);
      },
    );
  }

  getDateText(date: Date) {
    return this.dateUtils.getLastModifiedText(date);
  }

  async refreshCache() {
    const quickCalculations = await this.quickCalculationManager.list();

    this.quickCalculations$.next(quickCalculations);
  }

  loadQuickCalculation(quickCalculation: QuickCalculationCacheModel) {
    this.quickCalculationSelected = quickCalculation;
    if (quickCalculation.type === CalculationKeynameEnum.WithholdingTax) {
      this.goTo(ToolboxStateEnum.SalaryContributions);
    }
  }

  goTo(state: ToolboxStateEnum) {
    this.state = state;

    if (state === ToolboxStateEnum.Home) {
      this.quickCalculationSelected = undefined;
      this.refreshCache();
    }
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case OffcanvasDismissReasons.ESC:
        return 'by pressing ESC';
      case OffcanvasDismissReasons.BACKDROP_CLICK:
        return 'by clicking on the backdrop';
      default:
        return `with: ${reason}`;
    }
  }
}
